import getIn from 'lodash/get';

import { ApiActions } from '../../constants/ApiActions';
import { Map } from '../../lib/ImmutableUtils';
import { createReducer } from '../../lib/ReducerUtils';

const INITIAL_STATE = Map<$TSFixMe>({});
export type EntitiesGenresState = typeof INITIAL_STATE;

// GENRE ENTITY REDUCER
export default createReducer(INITIAL_STATE, {
  [ApiActions.SEARCH_RECOMMENDATIONS_SUCCESS]: saveGenreData,
  [ApiActions.FETCH_STATIONS_SUCCESS]: saveGenreData,
  [ApiActions.FETCH_GENRES_BY_CATEGORY_ID_SUCCESS]: saveGenreData,
});

// CASE FUNCTIONS

function saveGenreData(state: EntitiesGenresState, action: $TSFixMe): EntitiesGenresState {
  if (getIn(action, 'response.entities.genres')) {
    return state.mergeDeep(action.response.entities.genres);
  }
  return state;
}
